import Axios from "axios";
import storage from "./storage";
import { notify } from "../shared/alertToastify";

function authRequestInterceptor(config) {
    const token = storage.getToken();

    if (token) {
        config.headers.authorization = `Bearer ${token}`;
    }

    config.headers.Accept = "application/json";
    return config;
}

const base_url =
    process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_TEST_API
        : process.env.REACT_APP_PRODUCT_API;
export const axios = Axios.create({
    baseURL: base_url,
});

// interceptors ....
axios.interceptors.request.use(authRequestInterceptor);

// 에러 노티 주도록
axios.interceptors.response.use(
    (res) => {
        return res.data;
    },
    (err) => {
        const msg = err.response?.data?.errMsg || err.message;
        notify(msg, "error");
        return Promise.reject(err);
    }
);
